import { useRouter } from 'next/router';

const useBlogPreviewQuery = (): ((pathname: string) => string) => {
	const router = useRouter();
	const { preview } = router.query;

	return (pathname: string) => `${pathname}${preview ? '?preview=true' : ''}`;
};

export default useBlogPreviewQuery;
